export var Fuel;
(function (Fuel) {
    Fuel["DIESEL"] = "DIESEL";
    Fuel["EV"] = "EV";
    Fuel["GASOLINE"] = "GASOLINE";
    Fuel["HYBRID"] = "HYBRID";
    Fuel["LPG"] = "LPG";
})(Fuel || (Fuel = {}));
